angular.module('gym.gocardless').factory('GoCardless', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('gocardless');
}]);
